module.exports = __webpack_public_path__ + "static/media/a5.04e106d6.pdf";